// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2uGPu","avatar":"style_avatar__p-WKL"};